@let ctx =
  {
    setupPhase: setupPhase$ | async,
    loadingDialog: loadingDialog$ | async,
    coupledConnector: coupledConnector$ | async,
  };
<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup Calendly</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    @if (isCopyConfigurationButtonVisible) {
      <blaze-copy-connector-config-env-button
        [coupledConnector]="ctx.coupledConnector"
        (copyConfiguration)="copyConfiguration($event)"
      />
    }
    @if (isSaveButtonVisible) {
      <button
        [disabled]="connectorForm.invalid || !!(loading$ | async)?.connector || ctx.loadingDialog"
        (click)="saveConnector()"
        blazeBarButton="primary"
      >
        {{ saveButtonLabel }}
      </button>
    }
  </ng-container>

  <div content class="dialog-content">
    @if (ctx.loadingDialog === false) {
      <div class="flex flex-col items-center">
        @let ctx =
          {
            projects: (availableProjectOptions$ | async),
            tables: (availableTablesOptions$ | async),
            mappings: (availableMappings$ | async) ?? [],
            loading: (loading$ | async),
          };
        <form class="flex flex-col w-full" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
          <div class="form-control mb-22">
            <label class="field-label bd-field-label required">Name your connector</label>
            <input
              formControlName="connectorName"
              name="connectorName"
              class="bd-text-input tall"
            />
          </div>
          <div class="form-control">
            <label class="field-label bd-field-label required">Personal Token</label>
            <input
              formControlName="personalToken"
              name="personalToken"
              autocomplete="off"
              class="bd-text-input tall"
            />
          </div>
          <div class="form-control">
            <label class="field-label bd-field-label required">Project</label>
            <div class="relative">
              <blaze-select
                [showSelection]="true"
                [multiselect]="false"
                [filtered]="true"
                [allowNone]="false"
                [formControl]="connectorForm.controls.projectId"
                [options]="ctx.projects ?? []"
              />
              <blaze-element-loading-indicator [isVisible]="ctx.loading?.projects" />
            </div>
          </div>
          <div class="form-control">
            <label class="field-label bd-field-label required">Table</label>
            <div class="relative">
              <blaze-select
                [showSelection]="true"
                [multiselect]="false"
                [filtered]="true"
                [allowNone]="false"
                [formControl]="connectorForm.controls.tableId"
                [options]="ctx.tables ?? []"
                [disabled]="isTableSelectDisabled"
              />
              <blaze-element-loading-indicator [isVisible]="ctx.loading?.tables" />
            </div>
          </div>
          <div class="form-control" formArrayName="mappings">
            <div class="tables">
              <label class="table-name-label field-label bd-field-label required">Field</label>
              <label class="table-field-label field-label bd-field-label">Table column</label>
              @for (
                mapping of connectorForm.controls.mappings.controls;
                track mapping;
                let index = $index
              ) {
                <blaze-mapping-row
                  [form]="mapping"
                  [availableMappings]="ctx.mappings"
                  [canRemove]="canRemoveMapping"
                  (remove)="removeMapping(index)"
                />
              }
              <div class="table-summary">
                <button
                  blazeButton="secondary"
                  class="add-table-btn"
                  (click)="addMapping()"
                  type="button"
                  blazeTooltip="Add mapping"
                >
                  <mat-icon svgIcon="icon_add_32" />
                  Mapping
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }
    <blaze-element-loading-indicator [isVisible]="ctx.loadingDialog" />
  </div>
</blaze-panel>
